export default __webpack_public_path__ + "static/carton3-e9ef99eb59df60f8d25e69d9363f67d1.png";